import type { AdminLiveResponse, Attendance } from "./types";

export interface AdminLiveState {
  data: AdminLiveResponse | null;
  paused: boolean;
}

export type AdminLiveAction =
  | { type: "success"; data: AdminLiveResponse }
  | { type: "failure" };

export const initialAdminLiveState: AdminLiveState = { data: null, paused: false };

export function adminLiveReducer(state: AdminLiveState, action: AdminLiveAction): AdminLiveState {
  if (action.type === "success") return { data: action.data, paused: false };
  return { data: state.data, paused: true };
}

export async function refreshAdminSnapshots(
  loadBootstrap: () => Promise<void>,
  loadLive: () => Promise<void>,
): Promise<void> {
  await Promise.all([loadBootstrap(), loadLive()]);
}

export function groupAttendanceBySession(rows: Attendance[]): Map<string, Attendance[]> {
  const grouped = new Map<string, Attendance[]>();
  for (const row of rows) {
    const sessionRows = grouped.get(row.session_id);
    if (sessionRows) sessionRows.push(row);
    else grouped.set(row.session_id, [row]);
  }
  return grouped;
}

